import { useState, FC } from 'react';
import { DEFAULT_REGION, GlobalCountries, CountryPhoneType } from 'common/constants';

import { Select } from '@fuxi/eevee-ui';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

import cx from './index.module.css';

interface Props {
  value?: string;
  onSelect?: (item: CountryPhoneType) => void;
  disabled?: boolean;
}

const SelectCountry: FC<Props> = ({ value, onSelect, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [list, setList] = useState<CountryPhoneType[]>(GlobalCountries);
  const onSearch = (value: string) => {
    const list = GlobalCountries.filter(
      (item) =>
        item.dialCode.includes(value) ||
        item.nameCN.includes(value.toLowerCase()) ||
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.iso2.toLowerCase().includes(value.toLowerCase()),
    );
    setList(list);
  };

  return (
    <Select
      disabled={disabled}
      suffixIcon={
        <>
          {isOpen ? (
            <CaretUpOutlined style={{ pointerEvents: 'none' }} />
          ) : (
            <CaretDownOutlined style={{ pointerEvents: 'none' }} />
          )}
        </>
      }
      showSearch
      onSearch={onSearch}
      defaultValue={DEFAULT_REGION}
      value={value}
      dropdownStyle={{ textAlign: 'left', width: 200, maxHeight: 300, overflow: 'auto', background: '#0f0f18' }}
      labelRender={({ value, label }) => <span>+ {value}</span>}
      dropdownMatchSelectWidth={false}
      open={isOpen}
      onDropdownVisibleChange={(visible) => setIsOpen(visible)}
      dropdownRender={() => (
        <div>
          {list.map((item) => (
            <div
              key={item.iso2}
              className={cx('select-country-option', value === item.dialCode && 'selected')}
              onClick={() => {
                onSelect?.(item);
                setIsOpen(false);
              }}>
              <span> {item.nameCN}</span> <span>+{item.dialCode}</span>
            </div>
          ))}
        </div>
      )}></Select>
  );
};

export default SelectCountry;
